import { combineReducers } from 'redux';
import filters from 'store/reducers/filter/filters';
import lodgingsAndReservationsFilter from 'store/reducers/filter/lodgingsAndReservationsFilter';

export default combineReducers({
  filters,
  lodgingsAndReservationsFilter
});